/**
 * DEV ONLY — a customer-user import file that hits every row-level rule once (MIL-392).
 *
 * Used by the developer button in `ImportCustomerUsersBusinessModal`. The BOM and `;` separator
 * match the downloadable template, and every row-level outcome the parser can produce is in there:
 * created (with different countries, phone formats incl. a +45 prefix, upper-case addresses that get normalised, and quoting), skipped (each reason code),
 * duplicate in file, and one address that already belongs to a user of the account, so the
 * "findes allerede" skip shows up too.
 *
 * Every address carries a random suffix, so pressing the button twice does not turn the second run
 * into twenty "findes allerede" rows. The local part keeps the `ai-test+e2e-` prefix on purpose:
 * that is what `onCleanupE2eUsers()` in lab-cloud matches when it deletes the Auth accounts an
 * import creates.
 */

const BOM = '﻿'

const HEADER = 'Fornavn;Efternavn;E-mail;Land (ISO2);Telefonnummer'

/**
 * Fallback for the row that must already exist. The modal passes a real user of the account it is
 * open on, since this one only exists on the account the seed data put it on.
 */
const DEFAULT_EXISTING_EMAIL = 'ai-test+business-user-1@milva.io'

export function buildImportEdgeCaseCsv(
  suffix: string = Math.random().toString(36).slice(2, 7),
  existingEmail: string = DEFAULT_EXISTING_EMAIL
): string {
  const email = (n: number): string =>
    `ai-test+e2e-import-${suffix}-t${String(n).padStart(2, '0')}@milva.io`

  const rows = [
    `Anna;Andersen;${email(1)};dk;12345678`,
    `Bo;Bertelsen;${email(2).toUpperCase()};DK;12 34 56 78`,
    `Cecilie;Carlsen;${email(3)};dk;12-34-56-78`,
    `Æbeltoft;Østergård;${email(5)};dk;12345678`,
    '',
    `"Eva, Marie";"O""Neil";${email(6)};dk;12345678`,
    `Frederik;Friis;   ${email(7)}   ;dk;12345678`,
    `Gitte;Gram;${email(8)};no;41234567`,
    `Hans;Hansen;${email(9)};gb;7911123456`,
    `Ida;Iversen;${email(10)};de;15123456789`,
    `Jens;Jensen;${email(11)};fr;612345678`,
    `Karen;Knudsen;${email(12)};dk;+45 12 34 56 78`,
    `;Larsen;${email(13)};dk;12345678`,
    `Mette;;${email(14)};dk;12345678`,
    'Niels;Nielsen;;dk;12345678',
    'Ole;Olsen;ole.milva.io;dk;12345678',
    'Pia;Poulsen;pia@milva;dk;12345678',
    'Quentin;Quist;quentin t18@milva.io;dk;12345678',
    `Rikke;Rask;${email(19)};;12345678`,
    `Søren;Sand;${email(20)};se;12345678`,
    `Tina;Thomsen;${email(21)};dk;`,
    `Ulla;Ulriksen;${email(22)};dk;1234`,
    `Viggo;Vind;${email(23)};dk;abcdefgh`,
    `Xenia;Xu;${email(1)};dk;12345678`,
    `Yrsa;Yde;${email(1).toUpperCase()};dk;12345678`,
    `Zeb;Zahle;${existingEmail};dk;12345678`,
    `Ægir;Aaberg;${email(28)};dk`,
    `Bent;Bak;${email(29)};dk;12345678;;;`,
  ]

  return `${BOM}${HEADER}\r\n${rows.join('\r\n')}\r\n`
}
